<template>
  <div>
    <CCol sm="12" class="pl-0 pr-0">
      <CRow>
        <!-- <div class="col-md-3 col-sm-6">
          <label for class="d-block-mob fz-12px d-block">Date Range (Date Of Purchase)</label>
          <div class="datepicker pos-r">
            <datepicker
              v-model="dateRange"
              @input="dateChange()"
              ref="datepicker"
              :model-config="datePickerConfig"
              :max-date="new Date()"
              is-range
              :masks="{ input: 'DD/MM/YYYY' }"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  :value="
                    !!inputValue.start && !!inputValue.end
                      ? inputValue.start + ' - ' + inputValue.end
                      : 'DD/MM/YYYY'
                  "
                  v-on="inputEvents.start"
                  class="form-control pos-r"
                  placeholder="DD/MM/YYYY"
                />
                <div
                  v-if="!!inputValue.start && !!inputValue.end"
                  class="cross-svg subscription-cross-svg"
                  @click="resetJoiningDate"
                >
                  <crossSVG />
                </div>
              </template>
            </datepicker>
            <div class="calendarsvg pos-a">
              <calendarSVG />
            </div>
          </div>
        </div>-->
        <div class="col-sm-6 col-md-3">
          <label for>Select Status</label>
          <select
            @change="filterChange(formData.status)"
            v-model="formData.status"
            name
            id
            class="form-control"
          >
            <option value>All</option>
            <option value="active">Active</option>
            <option value="expired">Expired</option>
          </select>
        </div>
        <div class="col-md-3 col-sm-6">
          <label class="col-sm-12 mb-0 d-none-mob1" for></label>
          <v-btn
            :loading="csvLoader"
            :disabled="isEmpty"
            @click="downloadCsv()"
            class="btn btn-primary mt-0"
            >Export</v-btn
          >
        </div>
      </CRow>
    </CCol>

    <CCol sm="12" class="pl-0 pr-0">
      <div class="subs-table ov-both">
        <table class="table userlistTable subscriptlistTable sub-width">
          <thead>
            <tr class="table-success">
              <!-- 1 -->
              <th scope="col" class="min-width-50">Sr No.</th>
              <!-- 2 -->
              <th scope="col" class="min-width-120">User name</th>
              <!-- 3 -->
              <th v-if="role != 'doctor' && role != 'allied'" scope="col" class="min-width-120">
                Centre Name
              </th>
              <!-- 4 -->
              <!-- <th v-if="role != 'doctor'" scope="col" class="min-width-120">
                No.of Subscribed centres
              </th>-->
              <!--  5-->
              <th scope="col">Status</th>
              <!--  6-->
              <th scope="col">Date of Purchase</th>
              <!--  7-->
              <th scope="col">Date of Expiry</th>
              <!-- 8 -->
              <th scope="col" class="min-width-130">Contact Number</th>
              <!-- 9 -->
              <!-- <th scope="col" class="min-width-130">Location</th> -->
              <!-- 10 -->
              <th scope="col">Plan</th>
              <!-- 11 -->
              <th scope="col">Validity</th>
              <!-- 12 -->
              <th scope="col">Action</th>
            </tr>
          </thead>

          <tbody>
            <!-- 1st row only for search -->
            <tr>
              <!-- 1. Filter Sr No-->
              <td></td>
              <!-- 2. Filter User name-->
              <td>
                <input
                  placeholder="Search"
                  v-model="formData.user_name"
                  @input="debounceSearch()"
                  class="form-control"
                />
              </td>
              <!-- 3. Filter centre name -->
              <td v-if="role != 'doctor' && role != 'allied'">
                <input
                  placeholder="Search"
                  v-if="role != 'doctor' && role != 'allied'"
                  v-model="formData.center_name"
                  @input="debounceSearch()"
                  class="form-control"
                />
              </td>
              <!-- 4. Filter No.of Subscribed centres -->
              <!-- <td v-if="role != 'doctor'">
                <p></p>
              </td>-->

              <!-- 5. Filter status -->
              <td>
                <div class="position-relative table-select">
                  <select
                    @change="filterChange(formData.status)"
                    v-model="formData.status"
                    name
                    id
                    class="form-control"
                  >
                    <option value>All</option>
                    <option value="active">Active</option>
                    <option value="expired">Expired</option>
                  </select>
                  <span class="drop-icon">
                    <i
                      aria-hidden="true"
                      class="
                        v-icon
                        mdi mdi-menu-down
                        theme--light
                        position-absolute
                      "
                    ></i>
                  </span>
                </div>
              </td>
              <!-- 6. Date of Purchase -->
              <td></td>
              <!-- 7. Date of expiry -->
              <td></td>
              <!-- 8. Filter Contact Number -->
              <td>
                <input
                  @input="debounceSearch()"
                  v-model="formData.mobile"
                  placeholder="Number"
                  class="form-control"
                />
              </td>
              <!-- 9.	Filter Location -->
              <!-- <td>
                <input
                  @input="debounceSearch()"
                  v-model="formData.location"
                  placeholder="Search"
                  class="form-control"
                />
              </td> -->
              <!-- 10.	Filter plan -->
              <td>
                <div class="position-relative table-select">
                  <select
                    @change="filterChange(formData.plan)"
                    v-model="formData.plan"
                    name
                    id
                    class="form-control"
                  >
                    <option value>All</option>
                    <option
                      v-for="(option, i) in planList"
                      :key="i"
                      :value="option.settings.plan_name"
                    >
                      {{ option.settings.plan_name }}
                    </option>
                  </select>
                  <span class="drop-icon">
                    <i
                      aria-hidden="true"
                      class="
                        v-icon
                        mdi mdi-menu-down
                        theme--light
                        position-absolute
                      "
                    ></i>
                  </span>
                </div>
              </td>
              <!-- 11.	Filter validity -->
              <td></td>
              <!-- 12.	Filter Action -->
              <td></td>
            </tr>

            <!-- 2st row only for data -->

            <tr
              v-show="!showLoader"
              v-for="(item, i) in subscriptionList"
              :key="i"
            >
              <!-- 1. Sr No-->
              <td>{{ item.sr_no }}</td>
              <!-- 2. User name-->
              <td>
                <div>{{ item.user_name }}</div>
              </td>
              <!-- 3. center name -->
              <td v-if="role != 'doctor' && role != 'allied'">
                <div class="center-name">{{ item.center_name }}</div>
              </td>
              <!-- 4. No.of Subscribed centres -->
              <!-- <td v-if="role != 'doctor'">
                <p>
                  <span>{{ item.center_id.length }}</span>
                  <span>/</span>
                  <span>{{ item.center_count }}</span>
                </p>
              </td>-->
              <!-- 5. status -->

              <td>
                <div>{{ item.user_subscription ? item.user_subscription.status : "UNSUBSCRIBED" }}</div>
              </td>
              <!-- 6. Date of Purchase -->
              <td>
                <div>
                  {{
                    item.user_subscription && item.user_subscription.date_of_purchase
                      ? dayJS(item.user_subscription.date_of_purchase).format(
                          formats.date_format
                        )
                      : "&#8213;"
                  }}
                </div>
              </td>
              <!-- 7. Date of Expiry   -->
              <td>
                <div>
                  {{
                    item.user_subscription && item.user_subscription.expiration_date
                      ? dayJS(item.user_subscription.expiration_date).format(
                          formats.date_format
                        )
                      : "&#8213;"
                  }}
                </div>
              </td>

              <!-- 8. Contact Number -->
              <td>
                <div>{{ item.mobile }}</div>
              </td>
              <!-- 9. Location -->
              <!-- <td>
                <div>
                  {{
                    item.user &&
                    item.user.address.current_address &&
                    item.user.address.current_address.city
                      ? item.user.address.current_address.city
                      : " &#8213;"
                  }}
                </div>
              </td> -->
              <!-- 10. plan -->
              <td>
                <div>{{ item.user_subscription ? item.user_subscription.name : "&#8213;" }}</div>
              </td>
              <!-- 11. validity -->
              <td>
                <div>{{ item.user_subscription ? item.user_subscription.validity_text : "&#8213;" }}</div>
              </td>
              <!-- 12. action -->
              <td class="action-div small-table-padding">
                <div>
                  <CDropdown
                    color="link"
                    size="lg"
                    :caret="false"
                    class="dropdowndocbox"
                  >
                    <template #toggler-content>
                      <verticalDotsSVG />
                    </template>
                    <CDropdownItem
                      v-if="
                        item.user_subscription && (
                          item.user_subscription.status == 'ACTIVE' ||
                          item.user_subscription.status == 'UPCOMING'
                        )
                      "
                      @click="doUnsubscribe(item)"
                      >Unsubscribe</CDropdownItem
                    >
                    <CDropdownItem @click="goToChat(item.user_id)"
                      >Message</CDropdownItem
                    >
                    <CDropdownItem @click="goToHistory(item)"
                      >History</CDropdownItem
                    >
                    <!-- For doctors: show Add Free Trial unless they are on Basic plan -->
                    <CDropdownItem
                      v-if="
                        item.user_subscription &&
                        item.user_subscription.role == 'doctor' &&
                        item.user_subscription.name !== 'Basic'
                      "
                      @click="openFreeTrialModal(item)"
                      >Add Free Trial</CDropdownItem
                    >
                    <!-- For centers: show Add Free Trial always (including new centers
                         with no subscription yet — user_subscription will be null) -->
                    <CDropdownItem
                      v-if="role != 'doctor' && role != 'allied'"
                      @click="openFreeTrialModal(item)"
                      >Add Free Trial</CDropdownItem
                    >
                  </CDropdown>
                </div>
              </td>
            </tr>

            <tr v-if="showLoader">
              <td colspan="10">
                <v-skeleton-loader
                  v-if="showLoader"
                  v-bind="attrs"
                  type="list-item-avatar, divider,list-item-avatar, divider,list-item-avatar, divider,list-item-avatar, divider,list-item-avatar,
                   divider,list-item-avatar,divider,list-item-avatar,divider,list-item-avatar,divider,list-item-avatar,divider,list-item-avatar"
                ></v-skeleton-loader>
              </td>
            </tr>

            <tr v-if="isEmpty">
              <td colspan="10">
                <div v-if="isEmpty">
                  <h2 class="text-center">No Data Found</h2>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <pagination
        v-if="!isEmpty"
        class="mx-6"
        :currentPage="formData.page"
        :recordPerPage="formData.records_per_page"
        :total="total"
        @changePage="changePage"
      />
    </CCol>

    <subscription-centre
      class="subscription-page"
      v-if="subscriptionCentreModal"
      :subscriptionCentreModal="subscriptionCentreModal"
      :centersInfo="centersInfo"
      :role="role"
      @close="subscriptionCentreModal = false"
    ></subscription-centre>

    <subscription-add-free
      v-if="subscriptionAddFreeModal"
      :subscriptionAddFreeModal="subscriptionAddFreeModal"
      :userSubscriptionData="userSubscriptionData"
      :role="role"
      :planList="planList"
      @close="subscriptionAddFreeModal = false"
      @refreshList="getSubscriptionList()"
    ></subscription-add-free>
  </div>
</template>


<script>
import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
import debounce from "lodash/debounce";
import Swal from "sweetalert2";
import ChatMixin from "@/common/ChatMixin";
// const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const subscriptionCentre = () =>
  import("@/components/subscriptions/subscriptionCentre.vue");
const subscriptionAddFree = () =>
  import("@/components/subscriptions/subscriptionAddFree.vue");
const pagination = () => import("@/views/common/Pagination");
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
import formats from "@/formats";

export default {
  mixins: [ChatMixin],
  props: ["role"],
  data() {
    return {
      // dateRange: { start: "", end: "" },
      // datePickerConfig: {
      //   start: {
      //     timeAdjust: "00:00:00"
      //   },
      //   end: {
      //     timeAdjust: "23:59:59"
      //   }
      // },

      // lastSeenDateRange: {},
      // dateRange: {
      //   start: "",
      //   end: ""
      // },
      // dateRangeActive: false,
      showLoader: false,
      subscriptionCentreModal: false,
      subscriptionAddFreeModal: false,
      total: 0,
      formData: {
        role: this.role,
        page: 1,
        records_per_page: 10,
        user_name: "",
        mobile: "",
        location: "",
        status: "",
        plan: "",
        center_name: "",
      },
      isEmpty: false,
      subscriptionList: {},
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 2,
      },
      userSubscriptionData: {},
      planList: [],
      centersInfo: [],
      dayJS,
      formats,
      sendData: {},
      csvLoader: false,
      registeredCentres: "",
      subscriptionsBought: "",
    };
  },

  components: {
    ...pickSvg(
      "verticalDotsSVG",
      "nonverifiedUserSVG",
      "verifiedUserSVG",
      "searchSVG",
      "crossSVG"
    ),
    // Datepicker,
    subscriptionCentre,
    subscriptionAddFree,
    pagination,
  },

  mounted() {
    this.getSubscriptionList();
  },

  methods: {
    downloadCsv() {
      this.csvLoader = true;
      let params = {
        ...this.formData,
        // start_date: this.dateRange.start.toString(),
        // end_date: this.dateRange.end.toString()
      };
      let url = `${config.BASE_URL}api/v2/admin/subscription/listing/csv`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.csvLoader = false;
          const data = response.data.data;
          this.download(data.fileName, data.csv);
        }
      });
    },

    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },

    goToHistory(data) {
      this.sendData = {
        role: this.role,
      };
      if (this.role === "doctor") {
        this.sendData.user_id = data.user_id;
      } else {
        this.sendData.user_id = data.user_id;
        this.sendData.center_id = data.center_id;
      }

      this.$router.push({
        name: "Subscription History",
        query: { ...this.sendData },
      });
    },

    goCentreDetails(data) {
      this.subscriptionCentreModal = true;
      this.centersInfo = data;
    },

    // open free trial modal logic
    openFreeTrialModal(data) {
      let params = {
        role: this.role,
        user_id: data.user_id,
      };

      if (this.role != "doctor") params.center_id = data.center_id;

      let url = `${config.BASE_URL}api/v2/admin/subscription/pre/assign-extended`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.data.has_upcoming && this.role === "doctor") {
          Swal.fire("This user already has an upcoming plan.");
        } else if (response.body.data.has_upcoming && this.role != "doctor") {
          Swal.fire("This centre already has an upcoming plan.");
        } else {
          data.all_center_expired = response.body.data.all_center_expired;
          this.userSubscriptionData = data;
          this.subscriptionAddFreeModal = true;
        }
      });
    },

    // do Unsubscribe logic
    doUnsubscribe(userData) {
      Swal.fire({
        title:
          "Are you sure you want to unsubscribe the user from all of their Active/Upcoming subscriptions?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          this.getUnsubscribe(userData.user_id);
        }
      });
    },

    getUnsubscribe(subscriptionId) {
      let obj = {
        role: this.role,
        user_id: subscriptionId,
      };
      let url = `${config.BASE_URL}api/v2/admin/subscription/unsubscribe`;
      this.$http.post(url, obj).then((response) => {
        if (response.body.status) {
          Swal.fire(response.body.message);
          this.getSubscriptionList();
        }
      });
    },

    // all filter change logic
    filterChange() {
      this.getSubscriptionList();
    },

    debounceSearch: debounce(function () {
      this.getSubscriptionList();
    }, 500),

    // calender close  logic
    // resetJoiningDate() {
    //   this.dateRange = { start: "", end: "" };
    //   this.getSubscriptionList();
    // },

    // change date logic
    // dateChange() {
    //   this.getSubscriptionList();
    // },

    // change page logic
    changePage(page) {
      this.formData.page = page.currentPage;
      this.getSubscriptionList();
    },

    // get plan logic
    getPlan() {
      this.showLoader = true;
      let params = {
        role: this.role,
      };
      let url = `${config.BASE_URL}api/v2/admin/subscriptions`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          if (response.body.data) {
            this.showLoader = false;
            this.planList = response.body.data;
          } else {
            this.showLoader = false;
            this.planList = {};
          }
        }
      });
    },

    // get subscriber user list logic
    getSubscriptionList() {
      this.showLoader = true;
      let params = {
        ...this.formData,
        // start_date: this.dateRange.start.toString(),
        // end_date: this.dateRange.end.toString()
      };
      let url;
      if (this.role === "doctor" || this.role === "allied") {
        url = `${config.BASE_URL}api/v2/admin/subscription/listing`;
      } else {
        url = `${config.SUBSCRIPTIONS_URL}api/v1/admin/subscriptions/listing`;
      }

      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          if (response.body.data.list.length) {
            this.getPlan();
            this.isEmpty = false;
            this.showLoader = false;
            this.subscriptionList = response.body.data.list;
            this.total = response.body.data.count;
            this.subscriptionList.map((el, index) => {
              return (el.sr_no =
                this.formData.records_per_page * this.formData.page -
                this.formData.records_per_page +
                1 +
                index);
            });
            this.subscriptionsBought =
              response.body.data.total_subscription_brought;
            this.registeredCentres = response.body.data.total_center_registered;
          } else {
            this.isEmpty = true;
            this.showLoader = false;
            this.subscriptionList = {};
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" >
.center-name {
  cursor: pointer;
}
.center-name:hover {
  color: #01a09b;
}
.subs-table {
  height: 100vh; // Added full height for dropdown modal
}
</style>